'use client';
import React from 'react';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Folding', href: '#services-detail' },
  { label: 'Collating', href: '#services-detail' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Contact', href: '#contact' },
];

export default function BottomNav() {
  return (
    <div
      style={{
        width: '100%',
        backgroundColor: '#414141',
        padding: '20px 0',
        borderBottom: '1px solid #555',
      }}
    >
      <div
        style={{
          maxWidth: '1140px',
          margin: '0 auto',
          textAlign: 'center',
          textTransform: 'uppercase',
          fontFamily: 'Lato, sans-serif',
        }}
      >
        {navLinks?.map((link, idx) => (
          <a
            key={link?.label}
            href={link?.href}
            style={{
              padding: '0 7px',
              color: '#fff',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 400,
              borderRight: idx < navLinks?.length - 1 ? '1px solid #666' : 'none',
              transition: 'color 0.2s',
            }}
            className="bottom-nav-link"
          >
            {link?.label}
          </a>
        ))}
      </div>
      <style jsx>{`
        .bottom-nav-link:hover { color: #f89921 !important; }
      `}</style>
    </div>
  );
}
